<div class="bucket">
    <div class="bucket-title">
        <h2 class="bucket-title" [i18n]="'realtime-tracking.load-tracking-map.bucket.search'"></h2>
        <i class="fas fa-chevron-left fa-x" (click)="hideBucket()"></i>
    </div>

    <div class="tabs">
        <div class="filter-tab tab" [ngClass]="[!displayableResults || resultTab ? '' : 'active']" (click)="resultTab = false"
             [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.filter'">
        </div>
        <div *ngIf="displayableResults" class="result-tab tab" [ngClass]="[resultTab ? 'active' : '']" (click)="resultTab = true">
            <span class="result-tab-title" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.result'"></span>
            <span class="result-number">{{resCount}}</span>
        </div>
    </div>

    <div class="tab-filter-content" *ngIf="!displayableResults || !resultTab">
        <div class="content">
            <div class="quick-filters">
                <h3 class="bucket-title _small" [i18n]="'realtime-tracking.load-tracking-map.bucket.quick-filters.title'"></h3>
                <div class="filters">
                    <button class="btn btn-sm" [ngClass]="{ 'btn-white': quickFilter !== QuickFilter.IN_PROGRESS, 'btn-primary active': quickFilter === QuickFilter.IN_PROGRESS }"
                            [disabled]="!carrier && !region" (click)="switchQuickFilter(QuickFilter.IN_PROGRESS)"
                            [i18n]="'realtime-tracking.load-tracking-map.bucket.quick-filters.in-progress'">
                    </button>
                    <button class="btn btn-sm" [ngClass]="{ 'btn-white': quickFilter !== QuickFilter.STARTED_TODAY, 'btn-primary active': quickFilter === QuickFilter.STARTED_TODAY }"
                            [disabled]="!carrier && !region" (click)="switchQuickFilter(QuickFilter.STARTED_TODAY)"
                            [i18n]="'realtime-tracking.load-tracking-map.bucket.quick-filters.today'">
                    </button>
                </div>
            </div>
            <div class="criteria-filter">
                <h3 class="bucket-title _small" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria-search'"></h3>
                <div class="ref-input data-filter">
                    <label for="ref-input" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.ref.label'"></label>
                    <input type="text" id="ref-input" class="form-control" (ngModelChange)="clearQuickFilter()" [(ngModel)]="refCriteria"
                           [i18n]="[{ target: 'attribute:placeholder', key: 'realtime-tracking.load-tracking-map.bucket.tabs.criteria.ref.placeholder' }]"
                           [class.success]="filterSuccess && refCriteria" [class.error]="filterError && refCriteria">
                </div>
                <div class="vehicle-input data-filter">
                    <label for="vehicle-input" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.vehicle.label'"></label>
                    <input type="text" id="vehicle-input" class="form-control" (ngModelChange)="clearQuickFilter()" [(ngModel)]="vehicleCriteria"
                           [i18n]="[{ target: 'attribute:placeholder', key: 'realtime-tracking.load-tracking-map.bucket.tabs.criteria.vehicle.placeholder' }]"
                           [class.success]="filterSuccess && vehicleCriteria" [class.error]="filterError && vehicleCriteria">
                </div>
                <div class="data-filter dates-input">
                    <div class="input-label dates-label" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.label'"></div>
                    <div class="sub-label" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.pickup'"></div>
                    <div class="creation-input date-input">
                        <div class="input">
                            <label for="creation-input-after" [i18n]="'time.between'"></label>
                            <input type="date" id="creation-input-after" class="form-control" [min]="dateMin" (ngModelChange)="dateChanged($event, true, true)" [(ngModel)]="departureAfterCriteria" [required]="true"
                                   [class.success]="filterSuccess && departureAfterCriteria" [class.error]="filterError && departureAfterCriteria">
                        </div>
                        <div class="separatorInputDate"></div>
                        <div class="input">
                            <label for="creation-input-before" [i18n]="'time.and'"></label>
                            <input type="date" id="creation-input-before" class="form-control" [min]="dateMin" (ngModelChange)="dateChanged($event, false, true)" [(ngModel)]="departureBeforeCriteria" [required]="true"
                                   [class.success]="filterSuccess && departureBeforeCriteria" [class.error]="filterError && departureBeforeCriteria">
                        </div>
                    </div>
                    <div class="sub-label" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.completion'"></div>
                    <div class="arrival-input date-input">
                        <div class="input">
                            <label for="arrival-input-after" [i18n]="'time.between'"></label>
                            <input type="date" id="arrival-input-after" class="form-control" [min]="dateMin" (ngModelChange)="dateChanged($event, true, false)" [(ngModel)]="arrivalAfterCriteria"
                                   [class.success]="filterSuccess && arrivalAfterCriteria" [class.error]="filterError && arrivalAfterCriteria">
                        </div>
                        <div class="separatorInputDate"></div>
                        <div class="input">
                            <label for="arrival-input-before" [i18n]="'time.and'"></label>
                            <input type="date" id="arrival-input-before" class="form-control" [min]="dateMin" (ngModelChange)="dateChanged($event, false, false)" [(ngModel)]="arrivalBeforeCriteria"
                                   [class.success]="filterSuccess && arrivalBeforeCriteria" [class.error]="filterError && arrivalBeforeCriteria">
                        </div>
                    </div>
                    <div class="switch">
                        <app-switcher class="switchFilter" [(ngModel)]="includeUnknownDates"></app-switcher>
                        <span class="input-label" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.include-unknown'" (click)="includeUnknownDates = !includeUnknownDates"></span>
                    </div>
                </div>
                <div class="status-input input">
                    <div class="status-label">
                        <div class="input-label" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.status.label'"></div>
                    </div>
                    <div class="input-container" [class.displayed]="!statusAll || showStatus">
                        <div class="input-line">
                            <div class="checkbox-input">
                                <label for="status-input-all">
                                    <input type="checkbox" id="status-input-all" [checked]="statusAll" (change)="allChanged()">
                                    <i class="fas fa-checkbox-icon"></i>
                                    <span [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.status.all'"></span>
                                </label>
                            </div>
                            <i class="fas show" [class.fa-caret-up]="showStatus" [class.fa-caret-down]="!showStatus" (click)="showStatus = !showStatus"></i>
                        </div>
                        <hr>
                        <div class="input-line" *ngIf="showStatus">
                            <div class="input-col">
                                <div class="checkbox-input">
                                    <label for="status-input-planned">
                                        <input type="checkbox" id="status-input-planned" [checked]="statusPlanned" (change)="statusPlannedChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.planned'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input">
                                    <label for="status-input-in-progress">
                                        <input type="checkbox" id="status-input-in-progress" [checked]="statusInProgress" (change)="inProgressChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.in_progress'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input">
                                    <label for="status-input-completed">
                                        <input type="checkbox" id="status-input-completed" [checked]="statusCompleted" (change)="completedChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.completed'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input">
                                    <label for="status-input-expired">
                                        <input type="checkbox" id="status-input-expired" [checked]="statusExpired" (change)="expiredChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.expired'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input">
                                    <label for="status-input-cancelled">
                                        <input type="checkbox" id="status-input-cancelled" [checked]="statusCancelled" (change)="cancelledChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.cancelled'"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="input-col">
                                <div class="checkbox-input">
                                    <label for="status-input-late">
                                        <input type="checkbox" id="status-input-late" [checked]="statusLate" (change)="statusLateChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.late'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input">
                                    <label for="status-input-on-time">
                                        <input type="checkbox" id="status-input-on-time" [checked]="statusOnTime" (change)="statusOnTimeChanged()">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.on_time'"></span>
                                    </label>
                                </div>
                                <div class="checkbox-input" [class._disabled]="!statusInProgress && (statusCompleted || statusExpired || statusPlanned || statusCancelled)">
                                    <label for="status-input-likely-late">
                                        <input type="checkbox" id="status-input-likely-late" [checked]="statusLikelyLate && !(!statusInProgress && (statusCompleted || statusExpired || statusPlanned || statusCancelled))"
                                               (change)="statusLikelyLateChanged()" [disabled]="!statusInProgress && (statusCompleted || statusExpired || statusPlanned || statusCancelled)">
                                        <i class="fas fa-checkbox-icon"></i>
                                        <span [i18n]="'realtime-tracking.common.trip-status.likely_late'"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="departure-address-input data-filter">
                    <label for="departure-address-input">
                        <span class="label-title" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.departure-address.label'"></span>
                        <i class="fas fa-info-circle" (click)="showAddressInfo = !showAddressInfo"></i>
                        <div class="input-info" *ngIf="showAddressInfo">
                            <div [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.help'"></div>
                            <div class="info-container">
                                <div>Or</div>
                                <div class="list">
                                    <div class="item" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.type.1'"></div>
                                    <div class="item" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.type.2'"></div>
                                    <div class="item" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.type.3'"></div>
                                    <div class="item" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.type.4'"></div>
                                    <div class="item" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.type.5'"></div>
                                </div>
                            </div>
                        </div>
                    </label>
                    <input type="text" id="departure-address-input" class="form-control" (ngModelChange)="clearQuickFilter()" [(ngModel)]="departSearch"
                           [i18n]="[{ target: 'attribute:placeholder', key: 'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.placeholder' }]"
                           [class.success]="filterSuccess && departSearch" [class.error]="filterError && departSearch">
                </div>
                <div class="arrival-address-input data-filter">
                    <label for="arrival-address-input">
                        <span class="label-title" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.arrival-address.label'"></span>
                    </label>
                    <input type="text" id="arrival-address-input" class="form-control" (ngModelChange)="clearQuickFilter()" [(ngModel)]="arrivalSearch"
                           [i18n]="[{ target: 'attribute:placeholder', key: 'realtime-tracking.load-tracking-map.bucket.tabs.criteria.address.placeholder' }]"
                           [class.success]="filterSuccess && arrivalSearch" [class.error]="filterError && arrivalSearch">
                </div>
            </div>
        </div>
        <div class="bottom-buttons">
            <button class="btn btn-sm erase" (click)="resetCriteria()">
                <i class="fas fa-ban fa-x"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.bucket.erase-criteria'"></span>
            </button>
            <button class="btn btn-sm search" (click)="searchTrips()" [disabled]="!carrier && !region">
                <i class="fas fa-search fa-x"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.bucket.search'"></span>
            </button>
        </div>
    </div>

    <div class="tab-result-content" *ngIf="displayableResults && resultTab">
        <div class="no-results" *ngIf="noResults">
            <div class="message" [i18n]="'realtime-tracking.load-tracking-map.bucket.no-results'"></div>
            <button class="btn btn-sm return" (click)="resultTab = false">
                <i class="fas fa-long-arrow-alt-left fa-2x"></i>
                <span [i18n]="'realtime-tracking.load-tracking-map.bucket.return'"></span>
            </button>
        </div>
        <div class="result" *ngIf="!noResults">
            <div class="trips-sorts">
                <select class="form-control" name="sort" id="sort" [(ngModel)]="sort" (ngModelChange)="changeSort($event)">
                    <option [ngValue]="'started_at'" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.pickup'"></option>
                    <option [ngValue]="'completed_at'" [i18n]="'realtime-tracking.load-tracking-map.bucket.tabs.criteria.dates.completion'"></option>
                    <option [ngValue]="'status'" [i18n]="'realtime-tracking.common.status'"></option>
                </select>
                <i class="fas fa-lg"
                   [class.chep-icon-cycle]="sort === 'status'"
                   [class.fa-angle-double-down]="sort !== 'status' && sortDirection === 'ASC'"
                   [class.fa-angle-double-up]="sort !== 'status' && sortDirection === 'DESC'"
                   (click)="changeSortDirection()">
                </i>
            </div>

            <div class="orders">
                <div class="order creation">
                    <div class="order-name" [i18n]="'realtime-tracking.common.trip'"></div>
                </div>
                <div class="order trip-detail-order">
                    <div class="order-name" [i18n]="'realtime-tracking.common.status'"></div>
                </div>
                <div class="order trip-detail-order">
                    <div class="order-name" [i18n]="'realtime-tracking.common.trip-status.likely_late'"></div>
                </div>
            </div>
            <div class="content" infiniteScroll [infiniteScrollThrottle]="100" [scrollWindow]="false" (scrolled)="loadNextPage()">
                <div class="trip" [class._active]="trip === selectedTrip" *ngFor="let trip of trips" (click)="selectTrip(trip)">
                    <i class="fas fa-times fa-x" (click)="removeTrip($event, trip)"></i>
                    <div class="trip-info-container">
                        <div class="trip-info">
                            <div class="trip-info-tracking">
                                <div class="trip-number">
                                    <div class="trip-load" *ngIf="trip.loadNumber"
                                         [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.bucket.load' }]">
                                        {{trip.loadNumber}}
                                    </div>
                                    <div class="trip-delivery" *ngIf="trip.deliveryNumbersInline || trip.deliveryNumbersInline !== ''"
                                         [i18n]="[{ target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.bucket.delivery' }]"
                                         [popover]="salesOrderPopTemplate" placement="top" container="body" triggers="mouseenter:mouseleave" containerClass="_maxTop">
                                        {{trip.deliveryNumbersInline}}
                                    </div>
                                    <ng-template #salesOrderPopTemplate>
                                        <chp-delivery-and-sales-order-numbers
                                            [deliveryNumbers]="trip.deliveryNumbers"
                                            [salesOrderNumbers]="trip.getSalesOrderNumbers()">
                                        </chp-delivery-and-sales-order-numbers>
                                    </ng-template>
                                </div>
                            </div>
                            <div class="info-container">
                                <div class="trip-global-info">
                                    <div class="trip-status" [ngClass]="[trip.status | lowercase]"
                                         [i18n]="('realtime-tracking.common.trip-status.'+(trip.status | lowercase))"></div>
                                    <div class="trip-delay" [ngClass]="[trip?.getTripStatus() | lowercase]"
                                         [i18n]="('realtime-tracking.common.trip-status.'+(trip?.getTripStatus() | lowercase))"></div>
                                </div>
                            </div>
                        </div>
                        <div class="trip-last-ping">
                            <span *ngIf="trip.latestPingCreatedAt">
                                <span [translate]="'realtime-tracking.common.last-ping'"></span>
                                <span> {{ dateService.durationFrom(trip.latestPingCreatedAt, moment(), false).duration }}</span>
                            </span>
                            <span *ngIf="!trip.latestPingCreatedAt" [i18n]="'realtime-tracking.common.no-last-ping'"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="criteria-buttons">
                <button class="btn btn-sm return" (click)="resultTab = false">
                    <i class="fas fa-long-arrow-alt-left fa-2x"></i>
                    <span [i18n]="'realtime-tracking.load-tracking-map.bucket.return'"></span>
                </button>
            </div>
        </div>
    </div>
</div>
